// Typy dla 3 sekcji wyswietlanych na karcie schroniska na liscie glownej.
// Tabele: shelter_urgent_needs, shelter_fundraiser, shelter_adoptions.

export interface ShelterUrgentNeed {
  id: string;
  shelter_id: string;
  text: string;
  sort_order: number;
  urgent_set_at: string;
}

export interface ShelterFundraiser {
  id: string;
  shelter_id: string;
  title: string;
  description: string | null;
  external_url: string;
  is_urgent: boolean;
  urgent_set_at: string | null;
  amount_raised: number | null;
  amount_goal: number | null;
  currency: string | null;
  stats_updated_at: string | null;
  stats_provider: string | null;
}

export type AdoptionSpecies = "pies" | "kot" | "inne";

export interface ShelterAdoption {
  id: string;
  shelter_id: string;
  name: string;
  age: string | null;
  species: AdoptionSpecies;
  description: string | null;
  photo_path: string | null;
  external_url: string | null;
  is_urgent: boolean;
  urgent_set_at: string | null;
  sort_order: number;
  created_at: string;
}

export interface ShelterSectionsBundle {
  urgentNeeds: ShelterUrgentNeed[];
  fundraiser: ShelterFundraiser | null;
  adoption: ShelterAdoption | null;
  hasAnySection: boolean;
}

export type ShelterSectionsMap = Record<string, ShelterSectionsBundle>;

// Sekcja jest "aktywnie pilna" gdy ma is_urgent=true i nie wygasla
// (90 dni od urgent_set_at - zbiorki i adopcje moga trwac dluzej niz pilne potrzeby).
const URGENT_TTL_DAYS = 90;

export const isSectionUrgentActive = (
  isUrgent: boolean,
  urgentSetAt: string | null,
): boolean => {
  if (!isUrgent) return false;
  if (!urgentSetAt) return true;
  const setAt = new Date(urgentSetAt);
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - URGENT_TTL_DAYS);
  return setAt > cutoff;
};
